import AppRecord from './AppRecord.js'

class DataStagingLog extends AppRecord {
}
export default DataStagingLog
